import { render, staticRenderFns } from "./historical_superadmin.vue?vue&type=template&id=0f7dc418"
import script from "./historical_superadmin.vue?vue&type=script&lang=js"
export * from "./historical_superadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports